import { generateHooks } from "../generators/generator.hooks";
import { GENERATOR_PARAMS } from "./scheduledExport.constants";
export var usePaged = generateHooks(GENERATOR_PARAMS).usePaged;
